import { LAYOUT } from '@admin/router/constant'

// 调拨v2
const transferRouter = {
  path: '/transfer',
  name: '',
  component: LAYOUT,
  children: [
    {
      path: '/wms/transfer/transfer-order-manage',
      name: 'wmsTransferOrderManage',
      component: () => import('@admin/views/wms/transfer/transferOrder/index.vue'),
      meta: { title: '调拨单管理' },
    },
    {
      path: '/wms/transfer/transfer-order-manage/details',
      name: 'wmsTransferOrderManageDetails',
      component: () => import('@admin/views/wms/transfer/transferOrder/details.vue'),
      meta: { title: '调拨单管理详情' },
    },
    {
      path: '/wms/transfer/transfer-order-manage/split',
      name: 'wmsTransferOrderManageSplit',
      component: () => import('@admin/views/wms/transfer/transferOrder/split.vue'),
      meta: { title: '拆分调拨单' },
    },
    {
      path: '/wms/transfer/picking-tasks/list',
      name: 'wmsTransferPickingTasksList',
      component: () => import('@admin/views/wms/transfer/pickingTasks/index.vue'),
      meta: { title: '调拨拣货任务' },
    },
    {
      path: '/wms/transfer/loss-reported',
      name: 'wmsTransferLossReported',
      component: () => import('@admin/views/wms/transfer/lossReported/index.vue'),
      meta: { title: '调拨报损列表' },
    },
    {
      path: '/wms/transfer/picking-tasks/detail',
      name: 'wmsTransferPickingTasksDetail',
      component: () => import('@admin/views/wms/transfer/pickingTasks/detail.vue'),
      meta: { title: '调拨拣货作业' },
    },
    {
      path: '/wms/transfer/packing-list/work',
      name: 'wmsTransferPickingListWork',
      component: () => import('@admin/views/wms/transfer/packingList/work/index.vue'),
      meta: { title: '集箱作业' },
    },
    {
      path: '/wms/transfer/packing-list/put-on-shelves',
      name: 'wmsTransferPickingListPutOnShelves',
      component: () => import('@admin/views/wms/transfer/packingList/putOnShelves/index.vue'),
      meta: { title: '集箱单上架' },
    },
  ],
}

export default [transferRouter]
